import { useCallback } from "react";
import { Flame } from "lucide-react";
import { posterFor } from "@/lib/journey";
import { ShareCardDialog, cardBase } from "@/components/ShareCard";

export const STREAK_MILESTONES = [
  { days: 7, label: "ONE WEEK", line: "Seven mornings. Seven times you chose the ground.", scene: "m7" },
  { days: 30, label: "ONE MONTH", line: "Thirty days. This is no longer a try. It is who you are.", scene: "m8" },
  { days: 100, label: "ONE HUNDRED DAYS", line: "A hundred days. Change, sustained.", scene: "m5" },
];

export const milestoneFor = (streak) =>
  [...STREAK_MILESTONES].reverse().find((m) => streak >= m.days) || null;

export const isMilestone = (streak) => STREAK_MILESTONES.some((m) => m.days === streak);

export const drawStreakCard = async (streak, firstName) => {
  const m = milestoneFor(streak) || STREAK_MILESTONES[0];
  const { canvas, ctx: x } = await cardBase(posterFor(m.scene));
  x.fillStyle = "#F59E0B";
  x.font = "30px 'Courier New', monospace";
  x.fillText(m.label.split("").join(" "), 540, 700);
  x.fillStyle = "#FFFFFF";
  x.font = "260px Georgia, serif";
  x.fillText(String(streak), 540, 940);
  x.fillStyle = "#F59E0B";
  x.font = "34px 'Courier New', monospace";
  x.fillText("D A Y   S T R E A K", 540, 1000);
  x.fillStyle = "#44403C";
  x.font = "italic 30px Georgia, serif";
  x.fillText(m.line, 540, 1070);
  x.fillStyle = "#F59E0B";
  x.font = "italic 36px Georgia, serif";
  x.fillText(`— ${firstName}, grounded every day.`, 540, 1140);
  return canvas;
};

export const StreakShareDialog = ({ open, onOpenChange, streak, firstName }) => {
  const draw = useCallback(() => drawStreakCard(streak, firstName), [streak, firstName]);
  const m = milestoneFor(streak);
  if (!m) return null;
  return (
    <ShareCardDialog
      open={open}
      onOpenChange={onOpenChange}
      draw={draw}
      testId="streak-share"
      title={`${streak}-day streak. Say it out loud.`}
      description={`${m.label.charAt(0)}${m.label.slice(1).toLowerCase()} of grounding, every single day.`}
      fileName={`TACC-${streak}-day-streak.png`}
      shareText={`${streak} days grounded, every day. Through Adversity Comes Change. tacc.love`}
    />
  );
};

export const StreakShareButton = ({ streak, onClick }) => {
  const m = milestoneFor(streak);
  if (!m) return null;
  return (
    <button onClick={onClick} data-testid="streak-share-btn" className="btn-outline text-xs ml-2" title="Share your streak card">
      <Flame size={12} className="text-[#B45309]" /> Share {m.days}-day streak
    </button>
  );
};
